import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Lock } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-24 bg-warm-deep relative overflow-hidden" data-id="element-102">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-30" data-id="element-103">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gold/20 rounded-full blur-3xl" data-id="element-104" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cream/50 rounded-full blur-3xl" data-id="element-105" />
      </div>

      <div className="max-w-3xl mx-auto px-6 md:px-8 text-center relative z-10" data-id="element-106">
        <FadeIn data-id="element-107">
          <p className="text-2xl md:text-3xl font-heading text-brown mb-8 leading-relaxed" data-id="element-108">
            Recupera tu paz por menos de lo que cuesta un café y un postre.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-109">
          <div className="bg-cream/80 backdrop-blur-sm p-8 md:p-12 rounded-3xl shadow-xl border border-white/50 mb-10" data-id="element-110">
            <p className="text-lg md:text-xl text-brown-light mb-8 italic" data-id="element-111">
              "Tu tranquilidad no es un lujo, es la base de la felicidad de tus
              hijos. Sanar tú es el mejor regalo que puedes darles."
            </p>

            <div className="mb-8" data-id="element-112">
              <span className="text-sm font-bold text-gold-dark uppercase tracking-widest mb-3 block" data-id="element-113">
                Inversión Especial
              </span>

              {/* Discount badge */}
              <span className="inline-block bg-red-600 text-white text-sm font-bold px-4 py-1.5 rounded-full mb-4 animate-pulse-slow" data-id="element-114">
                🔥 65% DE DESCUENTO — OFERTA LIMITADA
              </span>

              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-115">
                {/* Original price crossed out */}
                <span className="text-2xl text-brown-light/50 line-through decoration-red-400 decoration-2" data-id="element-116">
                  €20.00
                </span>
                {/* Current price */}
                <span className="text-6xl font-bold text-brown" data-id="element-117">€6.99</span>
                <span className="text-xl text-brown-light ml-1" data-id="element-118">EUR</span>
              </div>

              <p className="text-sm text-sage font-medium mt-2" data-id="element-119">
                Ahorras €13.01 hoy
              </p>
            </div>

            <a href="https://caosacalma.com/cart/56509401694532:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart');
            }
          }} className="w-full bg-gold hover:bg-gold-dark text-white text-lg md:text-xl font-bold py-5 px-8 rounded-full transition-all duration-300 shadow-lg shadow-gold/30 hover:shadow-xl hover:shadow-gold/40 hover:-translate-y-1 animate-pulse-slow flex items-center justify-center gap-1 no-underline" data-id="element-120">
              QUIERO MI GUÍA Y MI AUDIO SALVAVIDAS AHORA
            </a>

            <div className="flex items-center justify-center gap-2 mt-6 text-sm text-brown-light/80" data-id="element-121">
              <Lock size={14} data-id="element-122" />
              <span data-id="element-123">
                Pago 100% seguro. Acceso inmediato al finalizar tu compra.
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}